import { type AnyRoute, routeMap } from '../route.ts'

export const findRoute = (
  localPath: string | undefined
): AnyRoute | undefined => {
  if (localPath) {
    const route = Object.values(routeMap).find((route) =>
      route().isMatch(localPath)
    )
    return route ? route() : undefined
  }
}

export const assertFindRoute = (localPath: string | undefined): AnyRoute => {
  const route = findRoute(localPath)

  if (!route) {
    throw new Error(`Route not found for path: ${localPath}`)
  }

  return route
}

export type FindRouteAncestryOptions = {
  includeSelf?: boolean
  depth?: number
}
